module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "image-display"
  }, [_c('img', {
    staticClass: "sitterphoto",
    attrs: {
      "id": "imgPrev",
      "src": _vm.photoComp,
      "crossOrigin": "Anonymous"
    }
  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "progress progress-image"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ({
      width: _vm.uploadCompletePct
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.uploadStatusPct))])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "my-button"
  }, [_c('label', {
    staticClass: "btn btn-title btn-success"
  }, [_vm._v("\n        Upload Photo "), _c('i', {
    staticClass: "fa fa-camera"
  }), _c('input', {
    staticClass: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/jpeg, image/bmp, image/png"
    },
    on: {
      "change": _vm.previewThumbnail
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "profilePicModal",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "max-width": "100%",
      "max-height": "300px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "300px"
    },
    attrs: {
      "id": "profilePicCropper",
      "src": _vm.uploadedImageSrc,
      "alt": "Picture",
      "crossorigin": ""
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-title btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.saveImage
    }
  }, [_vm._v("\n              Save Image\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-title btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.cancelSave
    }
  }, [_vm._v("\n              Cancel\n            ")])])])])])]), _vm._v(" "), _c('div')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalLabel"
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" Account Picture\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "docs-preview clearfix"
  }, [_c('div', {
    staticClass: "img-preview"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a1643c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/ProfilePicUpload.vue
// module id = 642
// module chunks = 2